import { render, staticRenderFns } from "./NewCustomerInviteDetail.vue?vue&type=template&id=3581a006&scoped=true"
import script from "./NewCustomerInviteDetail.vue?vue&type=script&lang=js"
export * from "./NewCustomerInviteDetail.vue?vue&type=script&lang=js"
import style0 from "./NewCustomerInviteDetail.vue?vue&type=style&index=0&id=3581a006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3581a006",
  null
  
)

export default component.exports